import _getIterator from 'babel-runtime/core-js/get-iterator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var env = require('zrender/lib/core/env');
import { getMaxIndex, downloadImage } from '@/utils';

export default {
  name: 'vue-picture-viewer',
  props: {
    imgData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    background: {
      type: String,
      default: 'rgba(0,0,0,0.4)'
    },
    // 选择的索引
    selectIndex: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      // 默认不显示左右切换箭头
      leftArrowShow: false,
      rightArrowShow: false,
      // 图片容器数据
      rotateDeg: 0,
      bigImgUrl: '',
      bigShowType: { isImage: true, icon: '' }, //不是图片的时候 展示 icon
      bigImgName: '',
      imgLength: 0,
      imgIndex: 0,
      showTips: false,
      tipsText: '',
      bigImgConWidth: '',
      bigImgConHeight: '',
      maskContainer: {
        width: '100%',
        height: '100%',
        background: this.background,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      imgContainer: {
        width: 'auto',
        height: 'auto',
        position: 'absolute',
        top: '50%',
        left: '50%',
        'z-index': 100,
        transform: 'translate(-50%, -50%)'
      },
      bigImgStyle: {
        display: 'block',
        width: '80px',
        height: '80px',
        position: 'absolute',
        top: 50 + '%',
        left: 50 + '%',
        marginLeft: '',
        marginTop: '',
        userSelect: 'none'
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    document.getElementById('vue-picture-viewer').addEventListener('click', function (e) {
      e.stopPropagation();
    });

    this.imgLength = this.imgData.length;
    this.imgIndex = this.selectIndex;
    this.$nextTick(function () {
      _this2.bigImgUrl = _this2.imgData[_this2.imgIndex].url;
      _this2.getShowTypeInfo(_this2.bigImgUrl);
      _this2.bigImgName = _this2.imgData[_this2.imgIndex].name;
      if (_this2.imgLength > 1) {
        // 大于1的时候才会展示缩略图
        var item = _this2.$refs.thumbnailItem;
        item[_this2.imgIndex].className = 'borderActive';
      }
    });
    var self = this;
    this.$refs.bigImg.onload = function () {
      self.init();
    };

    this.maskContainer['z-index'] = getMaxIndex();
  },

  methods: {
    // init
    init: function init() {
      var screenW = document.documentElement.offsetWidth || document.body.offsetWidth;
      var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
      this.$nextTick(function () {
        var ratio = [0.1, 0.2, 0.3, 0.4, 0.5, 0.7, 0.8, 0.9];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(ratio), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (this.$refs.bigImg.naturalWidth * item < screenW && this.$refs.bigImg.naturalHeight * item < screenH - 200) {
              this.bigImgConWidth = this.$refs.bigImg.naturalWidth * item;
              this.bigImgConHeight = this.$refs.bigImg.naturalHeight * item;
              this.imgContainer.width = this.bigImgConWidth + 'px';
              this.imgContainer.height = this.bigImgConHeight + 'px';
              this.bigImgStyle.width = this.bigImgConWidth + 'px';
              this.bigImgStyle.height = this.bigImgConHeight + 'px';
              this.bigImgStyle.marginLeft = -(this.bigImgConWidth / 2) + 'px';
              this.bigImgStyle.marginTop = -(this.bigImgConHeight / 2) + 'px';
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },

    // rotate init
    rotateInit: function rotateInit() {
      var screenW = document.documentElement.offsetWidth || document.body.offsetWidth;
      var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var ratio = [0.1, 0.2, 0.3, 0.4, 0.5, 0.7, 0.8, 0.9];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(ratio), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (this.$refs.bigImg.naturalWidth * item < screenH - 160) {
            this.bigImgConWidth = this.$refs.bigImg.naturalWidth * item;
            this.bigImgConHeight = this.$refs.bigImg.naturalHeight * item;
            this.imgContainer.width = this.bigImgConWidth + 'px';
            this.imgContainer.height = this.bigImgConHeight + 'px';
            this.bigImgStyle.width = this.bigImgConWidth + 'px';
            this.bigImgStyle.height = this.bigImgConHeight + 'px';
            this.bigImgStyle.marginLeft = -(this.bigImgConWidth / 2) + 'px';
            this.bigImgStyle.marginTop = -(this.bigImgConHeight / 2) + 'px';
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },

    // 放大
    enlarge: function enlarge() {
      this.$nextTick(function () {
        var screenW = document.documentElement.offsetWidth || document.body.offsetWidth;
        var screenH = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (this.$refs.bigImg.offsetWidth >= this.$refs.bigImg.offsetHeight && this.$refs.bigImg.offsetHeight * 2 < screenH * 2 || this.$refs.bigImg.offsetHeight >= this.$refs.bigImg.offsetWidth && this.$refs.bigImg.offsetWidth * 2 < screenW * 2) {
          this.$refs.bigImg.style.width = this.$refs.bigImg.offsetWidth * 1.3 + 'px';
          this.$refs.bigImg.style.height = this.$refs.bigImg.offsetHeight * 1.3 + 'px';
          this.$refs.bigImg.style.left = '50%';
          this.$refs.bigImg.style.top = '50%';
          this.bigImgStyle.marginLeft = -this.$refs.bigImg.offsetWidth / 2 + 'px';
          this.bigImgStyle.marginTop = -this.$refs.bigImg.offsetHeight / 2 + 'px';
        }
      });
    },

    // 缩小
    reduce: function reduce() {
      if (this.$refs.bigImg.offsetWidth > 80) {
        /** 
           * clientWidth = width + padding
             offsetWidth = width + padding + border  */
        this.$refs.bigImg.style.width = this.$refs.bigImg.offsetWidth * 0.7 + 'px';
        this.$refs.bigImg.style.height = this.$refs.bigImg.offsetHeight * 0.7 + 'px';
        this.$refs.bigImg.style.left = '50%';
        this.$refs.bigImg.style.top = '50%';
        this.bigImgStyle.marginLeft = -this.$refs.bigImg.offsetWidth / 2 + 'px';
        this.bigImgStyle.marginTop = -this.$refs.bigImg.offsetHeight / 2 + 'px';
      }
    },

    // 旋转
    rotate: function rotate() {
      if (this.rotateDeg === 0) {
        this.$refs.bigImg.style.transform = 'rotate(90deg)';
        this.rotateInit();
        this.rotateDeg++;
      } else if (this.rotateDeg === 1) {
        this.$refs.bigImg.style.transform = 'rotate(180deg)';
        this.init();
        this.rotateDeg++;
      } else if (this.rotateDeg === 2) {
        this.$refs.bigImg.style.transform = 'rotate(270deg)';
        this.rotateInit();
        this.rotateDeg++;
      } else if (this.rotateDeg === 3) {
        this.$refs.bigImg.style.transform = 'rotate(360deg)';
        this.init();
        this.rotateDeg = 0;
      }
    },

    // 点击缩略图切换图片
    switchImgUrl: function switchImgUrl(num, e) {
      var item = this.$refs.thumbnailItem;
      item.forEach(function (i) {
        i.className = '';
      });
      this.imgIndex = num;
      this.bigImgUrl = this.imgData[num].url;
      this.getShowTypeInfo(this.bigImgUrl);
      this.bigImgName = this.imgData[num].name;
      e.currentTarget.className = 'borderActive';
      if (this.bigShowType.isImage) {
        this.init();
      }
    },

    // 切换到上一张
    handlePrev: function handlePrev() {
      if (this.imgIndex <= 0) {
        this.tips('已经是第一张了!');
        this.imgIndex = 0;
      } else {
        if (this.$refs.bigImg) {
          this.$refs.bigImg.style.transform = 'rotate(0deg)';
          this.rotateDeg = 0;
        }

        this.imgIndex--;
        this.bigImgUrl = this.imgData[this.imgIndex].url;
        this.getShowTypeInfo(this.bigImgUrl);
        this.bigImgName = this.imgData[this.imgIndex].name;
        var item = this.$refs.thumbnailItem;
        item.forEach(function (i) {
          i.className = '';
        });
        item[this.imgIndex].className = 'borderActive';
        if (this.bigShowType.isImage) {
          this.init();
        }
      }
    },

    // 切换到下一张
    handleNext: function handleNext() {
      if (this.imgIndex + 1 >= this.imgData.length) {
        this.tips('已经是最后一张了!');
      } else {
        if (this.$refs.bigImg) {
          this.$refs.bigImg.style.transform = 'rotate(0deg)';
          this.rotateDeg = 0;
        }

        this.imgIndex++;
        this.bigImgUrl = this.imgData[this.imgIndex].url;
        this.getShowTypeInfo(this.bigImgUrl);
        this.bigImgName = this.imgData[this.imgIndex].name;

        var item = this.$refs.thumbnailItem;
        item.forEach(function (i) {
          i.className = '';
        });
        item[this.imgIndex].className = 'borderActive';
        if (this.bigShowType.isImage) {
          this.init();
        }
      }
    },

    // 提示框
    tips: function tips(msg) {
      this.showTips = true;
      this.tipsText = msg;
      var _this = this;
      setTimeout(function () {
        _this.showTips = false;
      }, 10000);
    },

    // 下载图片
    downloadImg: function downloadImg(data, filename) {
      downloadImage(data, filename);
    },

    // 鼠标左移
    enterLeft: function enterLeft() {
      this.leftArrowShow = true;
    },
    outLeft: function outLeft() {
      this.leftArrowShow = false;
    },

    // 鼠标右移
    enterRight: function enterRight() {
      this.rightArrowShow = true;
    },
    outRight: function outRight() {
      this.rightArrowShow = false;
    },

    // 关闭查看器
    closeViewer: function closeViewer() {
      this.$emit('close-viewer');
    },

    /** 附件逻辑 */
    fileHandle: function fileHandle(type) {
      var a = document.createElement('a');
      a.href = this.bigImgUrl;
      a.download = this.bigImgName ? this.bigImgName : '文件';
      a.target = '_black';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getShowTypeInfo: function getShowTypeInfo(url) {
      var temps = url ? url.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      var icon = '';
      var isImage = true;
      if (this.arrayContain(['jpg', 'png', 'gif', 'jpeg'], ext)) {
        isImage = true;
        icon = require('@/assets/img/file_img.png');
      } else if (this.arrayContain(['mp4', 'mp3', 'avi'], ext)) {
        isImage = false;
        icon = require('@/assets/img/file_excle.png');
      } else if (this.arrayContain(['xlsx', 'xls', 'XLSX', 'XLS'], ext)) {
        isImage = false;
        icon = require('@/assets/img/file_excle.png');
      } else if (this.arrayContain(['doc', 'docx', 'DOC', 'DOCX'], ext)) {
        isImage = false;
        icon = require('@/assets/img/file_word.png');
      } else if (this.arrayContain(['rar', 'zip'], ext)) {
        isImage = false;
        icon = require('@/assets/img/file_zip.png');
      } else if (ext === 'pdf') {
        isImage = false;
        icon = require('@/assets/img/file_pdf.png');
      } else if (ext === 'ppt' || ext === 'pptx') {
        isImage = false;
        icon = require('@/assets/img/file_ppt.png');
      } else if (this.arrayContain(['txt', 'text'], ext)) {
        isImage = false;
        icon = require('@/assets/img/file_txt.png');
      } else {
        isImage = false;
        icon = require('@/assets/img/file_unknown.png');
      }
      this.bigShowType = { isImage: isImage, icon: icon };
    },
    getFileTypeIconWithSuffix: function getFileTypeIconWithSuffix(url) {
      var temps = url ? url.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      if (this.arrayContain(['jpg', 'png', 'gif', 'jpeg'], ext)) {
        return require('@/assets/img/file_img.png');
      } else if (this.arrayContain(['mp4', 'mp3', 'avi'], ext)) {
        return require('@/assets/img/file_excle.png');
      } else if (this.arrayContain(['xlsx', 'xls', 'XLSX', 'XLS'], ext)) {
        return require('@/assets/img/file_excle.png');
      } else if (this.arrayContain(['doc', 'docx', 'DOC', 'DOCX'], ext)) {
        return require('@/assets/img/file_word.png');
      } else if (this.arrayContain(['rar', 'zip'], ext)) {
        return require('@/assets/img/file_zip.png');
      } else if (ext === 'pdf') {
        return require('@/assets/img/file_pdf.png');
      } else if (ext === 'ppt' || ext === 'pptx') {
        return require('@/assets/img/file_ppt.png');
      } else if (this.arrayContain(['txt', 'text'], ext)) {
        return require('@/assets/img/file_txt.png');
      }
      return require('@/assets/img/file_unknown.png');
    },
    isShowImage: function isShowImage(url) {
      var temps = url ? url.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      if (this.arrayContain(['jpg', 'png', 'gif', 'jpeg'], ext)) {
        return true;
      }
      return false;
    },
    arrayContain: function arrayContain(array, string) {
      return array.some(function (item) {
        return item === string;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (document.getElementById('vue-picture-viewer')) {
      document.getElementById('vue-picture-viewer').removeEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }
};